module.exports = __webpack_public_path__ + "static/media/ArunTangri.d41c6779.png";